import React, { useState } from 'react';
import { getToken } from '../../functions/app_functions.js';
import { loadStripe } from '@stripe/stripe-js';
import {
    Elements,
    CardElement,
    useStripe,
    useElements
} from '@stripe/react-stripe-js';

const stripePromise = loadStripe('pk_test_51RnnhtRxVVXd6M6jQEWjEdQmVcuCrvsg2QC3795OakKYjUhC2BsjwfyKqiEBoJyuCERHhtVUYI1uAoG0OQ78Qz4M00TqAxftpF');

function CheckoutForm(props) {
    const stripe = useStripe();
    const elements = useElements();
    const [status, setStatus] = useState('');

    const handleSubmit = async (event) => {
        event.preventDefault();

        if (!stripe || !elements) return;

        // Set laoding state
        props.setLoading();

        const card = elements.getElement(CardElement);

        // Create PaymentMethod
        const { error, paymentMethod } = await stripe.createPaymentMethod({
            type: 'card',
            card,
        });

        if (error) {
            // Track error
            setStatus(`Payment failed: ${error.message}`);
            props.setError("Payment failed", error.message);
            // Track event
            props.logEvent("Payment error", "StripePayment_handleSubmit");
            props.unsetLoading();
            return;
        }

        // Send PaymentMethod to your backend
        var response = await fetch(props.baseUrl + "/handlepayment", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${getToken()}`
            },
            body: JSON.stringify({
                paymentMethodId: paymentMethod.id,
                amount: props.amount,  // In cents
                user_id: props.user_id,
                trip_id: props.trip_id,
                trip_title: props.trip_title,
                owner_name: props.owner_name,
                owner_id: props.owner_id,
                items: props.items
            })
        });

        response = await response.json();
        const result = response.value;

        if (result && "success" in result && "payment_id" in result ) {
            if (result.success && result.payment_id) {
                setStatus('Payment successful!');
                await props.logEvent("User activity", "Payment made");
                props.handlePurchase();
                props.unsetLoading();
            } else {
                // Track error
                setStatus(`Payment failed: ${result.error}`);
                props.setError("Payment failed", result.error);
                // Track event
                props.logEvent("Payment error", "StripePayment_handleSubmit_1");
                props.unsetLoading();
                return;
            }
        } else {
            // Track error
            setStatus(`Payment failed: Technical error`);
            props.setError("Payment failed", "Technical error");
            // Track event
            props.logEvent("Payment error", "StripePayment_handleSubmit_2");
            props.unsetLoading();
            return;
        }
    };

    return (
        <form onSubmit={handleSubmit}>
            <div className="trip__popup__element trip__popup__element--stripe-element">
                <CardElement
                    options={{
                        style: {
                            base: {
                                color: '#331317',
                                fontFamily: 'arial',
                                fontSize: '16px',
                                '::placeholder': {
                                    color: '#CECACB',
                                }
                            },
                            invalid: {
                                color: '#aa5375',
                                iconColor: '#aa5375',
                            },
                        },
                    }}
                />
            </div>
            {status &&
                <div className={"text-small" + (status.includes("Payment successful!") ? " text-color-primary" : " text-color-tertiary")}>
                    {status}
                </div>
            }
            <div className="trip__popup__element trip__popup__buttonbox">
                {status !== "Payment successful!" &&
                    <button className={"button button-primary"} type="submit" disabled={!stripe}>
                        Pay
                    </button>
                }
            </div>
        </form >
    );
}

export default function StripePayment(props) {
    return (
        <Elements stripe={stripePromise}>
            <CheckoutForm {...props} />
        </Elements>
    );
}
